import React from 'react';
import ErrorLayout from './ErrorLayout';
import { connect } from 'react-redux';

const messages = {
  errorTitle: { id: 'SEARCH_RESULTS.TOO_FAR_ERROR_MESSAGE' },
};

const TooFarError = (props) => {
  return (
    <ErrorLayout
      {...props}
      titleMessage={messages.errorTitle}
      message={props.message}
    />
  );
};

const mapStateToProps = (state) => ({
  message: state.searchResults.errored?.message,
});

export default connect(mapStateToProps)(TooFarError);
